import { BRAND } from "../brand";

export const core = {
  brand: { name: BRAND.name, tagline: BRAND.tagline.tr },
  units: {
    days_one: "{count} gün",
    days_other: "{count} gün",
    hours_one: "{count} saat",
    hours_other: "{count} saat",
  },
  errors: {
    validation_failed: "Bazı alanları kontrol etmeniz gerekiyor.",
    unauthenticated: "Devam etmek için giriş yapın.",
    session_expired: "Oturumunuzun süresi doldu. Lütfen yeniden giriş yapın.",
    forbidden: "Bu işlem için yetkiniz yok. Gerekiyorsa İK ekibinize başvurun.",
    not_found: "Aradığınız kayıt bulunamadı ya da size açık değil.",
    conflict: "Bu kayıt başka bir işlemle çakışıyor.",
    stale_version: "Bu kayıt siz bakarken değişti. Güncel hâlini yükleyip tekrar deneyin.",
    idempotency_conflict: "Bu işlem az önce başka bir pencereden ya da cihazdan farklı bilgilerle yapıldı. Sayfayı yenileyip güncel durumu görün.",
    rate_limited: "Çok fazla deneme yapıldı. Birkaç dakika sonra tekrar deneyin.",
    invalid_credentials: "E-posta veya parola hatalı.",
    account_locked: "Çok sayıda hatalı deneme nedeniyle hesap geçici olarak kilitlendi. 15 dakika sonra tekrar deneyin veya parolanızı sıfırlayın.",
    email_taken: "Bu e-posta adresiyle zaten bir hesap var. Giriş yapmayı deneyin.",
    invitation_invalid: "Davet bağlantısı geçersiz ya da kullanılmış. İK ekibinizden yeni davet isteyin.",
    invitation_expired: "Davetin süresi dolmuş. İK ekibinizden yeni davet isteyin.",
    token_invalid: "Bağlantı geçersiz ya da süresi dolmuş. Yeni bir bağlantı isteyin.",
    weak_password: "Parola en az 10 karakter olmalı.",
    insufficient_balance: "Bakiyeniz yetmiyor: {available} kullanılabilir, {requested} istendi.",
    overlapping_request: "Bu tarihlerde zaten bir izin talebiniz var.",
    no_working_days: "Seçtiğiniz tarihlerde iş günü yok; düşülecek izin olmadığı için talep oluşturulmadı.",
    invalid_date_range: "Bitiş tarihi başlangıçtan önce olamaz.",
    notice_period: "Bu izin türü için en az {days} gün önceden talep gerekiyor.",
    request_not_editable: "Bu talep artık değiştirilemez.",
    not_your_turn: "Bu talep şu anda sizin onayınızı beklemiyor.",
    self_approval: "Kendi talebinizi onaylayamazsınız.",
    file_too_large: "Dosya en fazla {maxMb} MB olabilir.",
    file_type_not_allowed: "Yalnızca PDF, JPG, PNG, HEIC veya WEBP yükleyebilirsiniz.",
    import_has_errors: "Dosyada düzeltilmesi gereken satırlar var.",
    already_done: "Bu işlem zaten yapılmış.",
    precondition_failed: "Bu işlem için önce gerekli adımları tamamlayın.",
    internal_error: "Beklenmeyen bir sorun oluştu. Verileriniz kaydedilmedi; lütfen tekrar deneyin.",
    network: "Bağlantı kurulamadı. İnternetinizi kontrol edip tekrar deneyin; girdiğiniz bilgiler korunuyor.",
    /**
     * `details.reason` için daha açık mesajlar (yeni hata kodu eklemeden; K-019). Sunucu, nedenin metni varsa
     * genel mesaj yerine bunu döner.
     */
    reasons: {
      support_read_only: "Destek oturumunda değişiklik yapılamaz. Bu işlemi firmanın yetkilisi yapmalı.",
      support_no_files: "Destek oturumunda dosya içerikleri, bordro ve dışa aktarımlar açılmaz.",
      support_ended: `${BRAND.name} destek oturumu sona erdi.`,
      support_access_disabled: `Bu şirket ${BRAND.name} destek erişimini kapattı. Açılması için şirkete başvurun.`,
      support_active: "Açık bir destek oturumunuz var. Yenisini başlatmadan önce onu bitirin.",
      tenant_suspended: `Şirketinizin ${BRAND.name} hesabı askıya alındı. Şirket yöneticinize başvurun.`,
      no_active_membership: "Hesabınız kapatılmış ya da askıya alınmış. Yeniden açılması için şirketinizin İK ekibine başvurun.",
      last_admin: "Bu hesap şirketin son sistem yöneticisi. Önce başka birine sistem yöneticisi rolü verin.",
      admin_account: "Sistem yöneticisi hesabını yalnız sistem yöneticileri askıya alabilir veya yeniden açabilir.",
      separation_of_duties: "Bu kaydın önceki onay adımını siz verdiniz; finans yerine onayı şirket yönetiminden başka biri verir.",
      ip_not_allowed: "Bu ağdan yönetim paneline erişilemez.",
      job_not_failed: "Yalnız başarısız işler yeniden denenebilir.",
      platform_locked: "Çok sayıda hatalı deneme nedeniyle panel hesabı 30 dakika kilitlendi. Daha sonra tekrar deneyin.",
      totp_required: "Doğrulama uygulamanızdaki 6 haneli kodu girin.",
      totp_invalid: "Doğrulama kodu hatalı ya da daha önce kullanıldı. Uygulamadaki güncel kodu girin.",
      totp_not_enrolled:
        "Bu panel hesabında iki adımlı doğrulama açık değil ve giriş için zorunlu. Komut satırıyla açın: platform-admin totp-enable --email <e-posta>",
    },
  },
  fieldErrors: {
    required: "Bu alan zorunlu.",
    invalid: "Geçerli bir değer girin.",
    too_small: "Değer çok kısa.",
    too_big: "Değer çok uzun.",
    invalid_email: "Geçerli bir e-posta adresi girin.",
    national_id_format: "TC kimlik numarası 11 haneli olmalı ve 0 ile başlamamalı.",
    national_id_checksum: "TC kimlik numarası doğrulanamadı; rakamları kontrol edin.",
    iban_format: "IBAN \"TR\" ile başlamalı ve 26 karakter olmalı.",
    invalid_date_range: "Bitiş tarihi başlangıçtan önce olamaz.",
    invalid_amount: "Geçerli bir miktar girin.",
    duplicate: "Bu değer başka bir kayıtta kullanılıyor.",
    weak_password: "Parola en az 10 karakter olmalı.",
    wrong_password: "Parola hatalı.",
    code_too_short: "Kod 8 karakterdir; eksik yazmış olabilirsiniz.",
  },
};
